// Last-resort lookup for when a batch can't be found by its compound _id
// (see resolveBatchesByBatchNo in web/src/statements for why batchNo is a
// safer anchor than productId here).
//
// SL only for now — reads CouchDB directly rather than Postgres because the
// avocado.batch sync is currently only turned on for PSM (see the SL-only
// warning on the /by-batch-no controller before reusing this for PSM).
function findBatchesByBatchNos (state, batchNos = []) {
  const uniqueBatchNos = [...new Set(batchNos)].filter(Boolean)
  if (!uniqueBatchNos.length) return Promise.resolve([])

  const selector = {
    $or: uniqueBatchNos.map(batchNo => ({
      _id: { $regex: `batchNo:${escapeRegex(batchNo)}$` }
    }))
  }

  // .find() resolves { docs, warning }, not allDocs' { rows: [{ doc }] } shape.
  // No supporting index for this selector (batchNo isn't its own field, only
  // embedded in _id), so this is a full scan — fine for a rare fallback only.
  return state.masterDataDB.find({ selector, limit: 1000 }).then(result => result.docs)
}

function escapeRegex (value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

module.exports = findBatchesByBatchNos
